import React, { useState } from 'react';
import { FormikProvider, useFormik } from 'formik';
import GenericButtons from '../../components/UI components/Buttons/GenericButtons';
import { Card } from 'react-bootstrap';
import GenericFormCard from '../../components/moduleCommonFormik/GenericFormCard.component';
import { t } from 'i18next';
import Loading from '../../components/portalComponents/Loading.component';
import StatusAlertPopup from '../../components/moduleCommonFormik/StatusAlertPopup';
import { cross } from '../../utils/Logo';
import { getFirstErrorKey, getNavigateTo } from '../../utils/utils';
import { useNavigate } from 'react-router-dom';
import { KYC_REGISTRATION_FIELDS } from '../../features/modules/EstateManagement/DSCRegistration/DscRegistration.const';
import noteIcon from '../../assets/logos/red Note.svg';
import { KYC_REGISTRATION } from '../../utils/formikValidation/FormikValidation';
import GenericPopupModal from '../moduleCommonFormik/GenericModalPopup.component';
import { endpoints, POST, requestInfo } from '../../services/modulesServices/userManagement.api';
import { Link } from 'react-router-dom';
import { EMUDRA_KYC_DASHBOARD_URL } from '../../utils/constants';

export const KYCRegistration = ({ dropdownData }: any) => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [modalDetails, setModalDetails] = useState<any>({});
    const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
    const [response, setResponse] = useState<any>(null);

    const navigate = useNavigate();

    const userType = localStorage.getItem('type') ? JSON.parse(localStorage.getItem('type') as any) : '';

    const formik = useFormik<any>({
        initialValues: {
            isUpdatable: true
        },
        onSubmit: () => {},
        validationSchema: KYC_REGISTRATION
    });
    const { values, setValues, errors, setFieldValue, setFieldTouched, setTouched } = formik;

    const onChange = async (e: any, field: string) => {
        try {
        } catch (e: any) {
            console.log(e);
            setIsLoading(false);
            let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || 'Something went wrong';
            setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    const handleOnClick = async () => {
        try {
            await KYC_REGISTRATION.validate(values, { abortEarly: false, context: values });
            try {
                const payload = {
                    RequestInfo: requestInfo(),
                    ...values,
                    gender: values.gender.code,
                    idProof: values.idProofbase64,
                    addressProof: values.addressProofbase64,
                    photo: values.photobase64
                };
                setIsLoading(true);
                const { data } = await POST(endpoints.kycSubmit, payload);
                setResponse(data);
                if (data.verificationURL) {
                    setConfirmationModal(true);
                } else {
                    throw new Error(data.errorMessage);
                }
                setIsLoading(false);
            } catch (e: any) {
                console.log(e);
                setIsLoading(false);
                let errMsg = e.message || e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('KYC_REGISTRATION_UNSUCCESSFUL_MSG', 'KYC Registration failed');
                setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        } catch (e: any) {
            console.log(e);
            setIsLoading(false);
            let errorField = getFirstErrorKey(errors);
            if (errorField) {
                const escapedErrorField = errorField.replace(/([[\].])/g, '\\$1');
                await setFieldTouched(errorField, true, true);
                let getErrorField: any = document.querySelector(`[name=${escapedErrorField}]`);
                getErrorField && getErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            setModalDetails({ show: true, title: 'Error!', para: 'Please fill in all the required details!', img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    const handleModalClose = (type: string) => {
        setModalDetails({ show: false });
        if (type === 'success') {
            navigate(getNavigateTo(userType));
        }
    };

    console.log(formik);

    return (
        <>
            {isLoading ? <Loading /> : <></>}

            <FormikProvider value={formik}>
                <Card className='card_border font-inter'>
                    <Card.Body>
                        <Card
                            className='card_border note mb-4 rounded-2 cursor-pointer'
                            onClick={() => {
                                window.open(EMUDRA_KYC_DASHBOARD_URL, '_blank');
                            }}
                        >
                            <Card.Body>
                                <Card.Text>
                                    <div className='d-flex'>
                                        <span>
                                            <i className='fa fa-exclamation-circle pe-2' aria-hidden='true'></i>
                                        </span>
                                        <b className='pe-2'> Important:</b>
                                        <span>{t('ALREADY_REGISTERED_E_SIGN_KYC', 'If you have already registered for the e-sign KYC, please click here to track the application status.')}</span>
                                    </div>
                                </Card.Text>
                            </Card.Body>
                        </Card>

                        {KYC_REGISTRATION_FIELDS?.map((val: any) => <GenericFormCard {...val} dropdownOptions={dropdownData} customHandleChange={onChange} />)}
                    </Card.Body>
                </Card>

                <GenericPopupModal
                    primaryAction={() => {
                        window.open(response?.verificationURL, '_blank');
                        navigate(getNavigateTo(userType));
                    }}
                    secondaryAction={() => {
                        setConfirmationModal(false);
                        navigate(getNavigateTo(userType));
                    }}
                    isVisible={confirmationModal}
                    title='Success'
                    size='md'
                    children={
                        <div className='p-4' style={{ backgroundColor: '#F5F5F6' }}>
                            <div className='lh-22'>
                                {/* <Link to={response?.verificationURL}> */}
                                {t('KYC_REGISTRATION_SUCCESS', 'Your KYC Registration Application has been submitted successfully. Please with the Video KYC.')}
                                {/* </Link> */}
                            </div>
                        </div>
                    }
                    primaryBtnTitle={t('PROCEED_TO_KYC', 'Proceed to KYC')}
                />
            </FormikProvider>

            <footer className='footer fixed-bottom footerBtnPatch'>
                <div className='d-flex justify-content-end  container me-3 ' style={{ padding: 15 }}>
                    <GenericButtons text={t('REGISTER', 'Register')} variant='primary' handleClick={handleOnClick} />
                </div>
            </footer>

            <StatusAlertPopup
                title={modalDetails.title}
                para={modalDetails.para}
                img={modalDetails.img}
                show={modalDetails.show}
                handleClose={() => handleModalClose(modalDetails.type)}
                type={modalDetails.type}
                reUpload={modalDetails.reUpload}
                handleSubmit={() => handleModalClose(modalDetails.type)}
            />
        </>
    );
};
